import HomePage from "./views/home/HomePage";
import HomePageSele from "./views/home-sele/HomePage";
// import SubjectPage from "./views/examens/subject/SubjectPage";
// import Problems from "./views/examens/problems/Problems";
import { seoConfigs } from './utils/seo';

// Helper function to create consistent metaInfo objects for routes
const createRouteMetaInfo = (seoConfig) => {
  return {
    seo: seoConfig
  };
};

const routes = [
  //--------------------------------------------------------
  // DEMOS
  //--------------------------------------------------------
  {
    path: '/demos/matching-pairs',
    name: "MatchingPairsDemo",
    component: () => import('./views/MatchingPairsDemo.vue'),
    meta: {
      seo: {
        title: 'Demostración de Pares Coincidentes - SeleAI',
        description: 'Prueba la funcionalidad de emparejar términos con sus definiciones correctas.',
        keywords: 'matching pairs, pares coincidentes, demo interactiva, aprendizaje'
      }
    }
  },
  //--------------------------------------------------------
  // APP
  //--------------------------------------------------------
  /**
   * START
   */
  {
    path: '/start',
    name: "Start",
    component: () => import('./views/start/Start.vue'),
    meta: {
      seo: {
        title: 'Comenzar - SeleAI',
        description: 'Sube tus archivos y comienza a utilizar SeleAI para tu aprendizaje personalizado.',
        keywords: 'subir archivos, comenzar SeleAI, aprendizaje personalizado'
      },
      noIndex: true
    }
  },
  {
    path: '/start-1',
    name: "Start",
    component: () => import('./views/start/Start.vue'),
    meta: {
      seo: {
        title: 'Comenzar - SeleAI',
        description: 'Sube tus archivos y comienza a utilizar SeleAI para tu aprendizaje personalizado.',
        keywords: 'subir archivos, comenzar SeleAI, aprendizaje personalizado'
      },
      noIndex: true
    }
  },
  {
    path: '/start-2',
    name: "Start",
    component: () => import('./views/start/Start.vue'),
    meta: {
      seo: {
        title: 'Comenzar - SeleAI',
        description: 'Sube tus archivos y comienza a utilizar SeleAI para tu aprendizaje personalizado.',
        keywords: 'subir archivos, comenzar SeleAI, aprendizaje personalizado'
      },
      noIndex: true
    }
  },
  {
    path: '/start-3',
    name: "Start",
    component: () => import('./views/start/Start.vue'),
    meta: {
      seo: {
        title: 'Comenzar - SeleAI',
        description: 'Sube tus archivos y comienza a utilizar SeleAI para tu aprendizaje personalizado.',
        keywords: 'subir archivos, comenzar SeleAI, aprendizaje personalizado'
      },
      noIndex: true
    }
  },
  {
    path: '/app',
    name: "Main",
    component: () => import('./views/app/Main.vue'),
    meta: {
      seo: {
        title: 'SeleAI',
        description: 'Sube tus archivos y comienza a utilizar SeleAI para tu aprendizaje personalizado.',
        keywords: 'subir archivos, comenzar SeleAI, aprendizaje personalizado'
      },
      noIndex: true
    }
  },
  {
    path: '/app/apuntes-preguntas-flashcards/:communityId',
    name: "AsignaturasComunidad",
    component: () => import('./views/app/Main.vue'),
    meta: {
      seo: {
        title: 'Asignaturas de Comunidad - SeleAI',
        description: 'Explora las asignaturas disponibles en tu comunidad educativa.',
        keywords: 'asignaturas, comunidad educativa, sele.ai'
      },
      noIndex: true
    }
  },
  {
    path: '/start-plan',
    name: "StartPlan",
    component: () => import('./views/app/StartPlan.vue'),
    meta: {
      seo: {
        title: 'SeleAI',
        description: 'Sube tus archivos y comienza a utilizar SeleAI para tu aprendizaje personalizado.',
        keywords: 'subir archivos, comenzar SeleAI, aprendizaje personalizado'
      },
      noIndex: true
    }
  },
  {
    path: '/app/mobile-upload/:token',
    name: "MobileUpload",
    component: () => import('./views/mobile/MobileUpload.vue'),
    meta: {
      seo: {
        title: 'Subir Fotos - SeleAI',
        description: 'Sube fotos desde tu móvil para crear documentos de estudio.',
        keywords: 'subir fotos móvil, fotos estudio, sele.ai móvil'
      },
      noIndex: true
    }
  },
  {
    path: '/go-to-premium',
    component: () => import('./components/pricing/GoToPremium.vue'),
    name: 'GoToPremium',
  },
  //--------------------------------------------------------
  // USERS
  //--------------------------------------------------------
  /**
   * LOGIN
   */
  {
    path: '/login',
    name: "LogIn",
    component: () => import('./views/profile/login/LoginPage.vue'),
    meta: createRouteMetaInfo({
      title: 'Iniciar Sesión - SeleAI',
      description: 'Accede a tu cuenta de sele.ai para continuar con tu aprendizaje personalizado.',
      keywords: 'iniciar sesión, cuenta sele.ai, acceso usuario'
    })
  },
    /**
   * USERS SETTINGS
   */
    {
      path: '/profile/configuration',
      component: () => import('./views/profile/configuration/ConfigPage.vue'),
      name: 'Configuracion',
      meta: createRouteMetaInfo({
        title: 'Configuración de Cuenta - SeleAI',
        description: 'Gestiona tu cuenta de sele.ai y personaliza tu experiencia de aprendizaje.',
        keywords: 'configuración cuenta, perfil usuario, preferencias sele.ai'
      })
    },
  /**
   * SHOP
   */
  //--------------------------------------------------------
  // PREMIUM
  //--------------------------------------------------------

  {
    path: '/premium',
    component: () => import('./views/premium/PremiumPage.vue'),
    name: 'Premium',
    meta: createRouteMetaInfo({
      title: 'Plan Premium - SeleAI',
      description: 'Desbloquea todas las funciones premium de sele.ai y maximiza tu aprendizaje.',
      keywords: 'plan premium, funciones avanzadas, sele.ai premium'
    })
  },
  {
    path: '/premium/success',
    component: () => import('./views/premium/SuccessfulSubscription.vue'),
    name: 'SuscripcionExitosa',
    meta: createRouteMetaInfo({
      title: '¡Suscripción Exitosa! - SeleAI Premium',
      description: '¡Bienvenido a sele.ai Premium! Tu cuenta ha sido actualizada con todas las funciones premium.',
      keywords: 'suscripción exitosa, premium activado, sele.ai premium'
    })
  },
  {
    path: '/premium/cancel',
    component: () => import('./views/premium/CancelledSubscription.vue'),
    name: 'SuscripcionCancelada',
    meta: createRouteMetaInfo({
      title: 'Suscripción Cancelada - SeleAI',
      description: 'Tu suscripción premium ha sido cancelada. Puedes volver a suscribirte en cualquier momento.',
      keywords: 'suscripción cancelada, cancelar premium, sele.ai'
    })
  },
  //--------------------------------------------------------
  // CHECKOUT
  //--------------------------------------------------------
  {
    path: '/checkout',
    component: () => import('./views/shop/checkout/CheckOutPage.vue'),
    name: 'CheckOut',
    meta: createRouteMetaInfo({
      title: 'Completar Compra - SeleAI',
      description: 'Finaliza tu compra de sele.ai de forma segura. A un paso de acceder a todas las funciones premium.',
      keywords: 'checkout, compra premium, pago seguro, sele.ai'
    })
  },
  /**
   * PROBLEM UPLOADER
   */
  {
    path: '/admin',
    component: () => import('./views/admin/AdminPage.vue'),
    meta: createRouteMetaInfo({
      title: 'Panel de Administración - SeleAI',
      description: 'Panel de administración para gestionar usuarios, contenido y configuraciones del sistema.',
      keywords: 'admin sele.ai, panel administración, gestión sistema'
    })
  },
  //--------------------------------------------------------
  // MOCKUPS
  //--------------------------------------------------------
  {
    path: '/mockups/bulk',
    component: () => import('./views/mockups/bulk/BulkUploader.vue'),
    meta: createRouteMetaInfo(seoConfigs.bulkMockup)
  },
  //--------------------------------------------------------
  // CONTACTO
  //--------------------------------------------------------
  {
    name: 'Contacto',
    path: '/contacto',
    component: () => import("./views/contact/Contact.vue"),
    meta: createRouteMetaInfo({
      title: 'Contacto - SeleAI',
      description: '¿Tienes preguntas? Contáctanos y te ayudaremos con cualquier consulta sobre sele.ai.',
      keywords: 'contacto, soporte, ayuda sele.ai'
    })
  },
  //--------------------------------------------------------
  // BLOG
  //--------------------------------------------------------
  {
    name: 'Blog',
    path: '/blog',
    component: () => import('./views/blog/BlogPage.vue'),
    meta: createRouteMetaInfo({
      title: 'Blog - SeleAI',
      description: 'Descubre artículos sobre técnicas de estudio, consejos de aprendizaje y novedades de sele.ai.',
      keywords: 'blog sele.ai, técnicas de estudio, consejos de aprendizaje'
    })
  },
  // BLOG PUBLISH ARTICLE
  {
    name: 'PublicarArticulo',
    path: '/blog/publicar-articulo/:id',
    component: () => import('./views/blog/PublishArticlePage.vue'),
    meta: createRouteMetaInfo({
      title: 'Publicar Artículo - Blog sele.ai',
      description: 'Comparte tus conocimientos y experiencias con la comunidad de sele.ai.',
      keywords: 'publicar artículo, blog sele.ai, compartir conocimiento'
    })
  },
  // BLOG VIEW ARTICLE
  {
    name: 'Articulo',
    path: '/blog/articulo/:article_path',
    component: () => import('./views/blog/ArticlePage.vue'),
    meta: createRouteMetaInfo({
      title: 'Artículo - Blog sele.ai',
      description: 'Lee artículos expertos sobre técnicas de estudio y aprendizaje personalizado.',
      keywords: 'artículo sele.ai, técnicas de estudio, aprendizaje personalizado'
    })
  },
  // ---------------------------------
  // ADMIN
  // ---------------------------------
  // UPLOAD IMAGES
  {
    path: '/upload/images',
    component: () => import('./views/admin/UploadImages.vue'),
    meta: createRouteMetaInfo({
      title: 'Subir Imágenes - SeleAI Admin',
      description: 'Herramienta administrativa para subir imágenes a la plataforma sele.ai.',
      keywords: 'subir imágenes, imágenes sele.ai, herramientas admin'
    })
  },

  // ---------------------------------
  //  POLITICS
  // ---------------------------------
  {
    path: '/politicas/cookies',
    component: () => import('./views/politiques/Cookies.vue'),
    meta: createRouteMetaInfo({
      title: 'Política de Cookies - SeleAI',
      description: 'Información sobre el uso de cookies en sele.ai y tus derechos al respecto.',
      keywords: 'política cookies, privacidad, protección datos, sele.ai'
    })
  },
  {
    path: '/politicas/privacidad',
    component: () => import('./views/politiques/Privicitat.vue'),
    name: 'Privacidad',
    meta: createRouteMetaInfo({
      title: 'Política de Privacidad - SeleAI',
      description: 'Descubre cómo sele.ai protege y gestiona tu información personal.',
      keywords: 'privacidad, protección datos, política privacidad, sele.ai'
    })
  },
  {
    path: '/politicas/legal',
    component: () => import('./views/politiques/Legal.vue'),
    meta: createRouteMetaInfo({
      title: 'Información Legal - SeleAI',
      description: 'Información legal importante sobre el uso de sele.ai.',
      keywords: 'información legal, términos legales, sele.ai legal'
    })
  },
  {
    path: '/politicas/terminos',
    component: () => import('./views/politiques/CondicionesGenerales.vue'),
    meta: createRouteMetaInfo({
      title: 'Términos y Condiciones - SeleAI',
      description: 'Lee los términos y condiciones para usar sele.ai.',
      keywords: 'términos y condiciones, acuerdo usuario, sele.ai legal'
    })
  },
  //--------------------------------------------------------
  // HOME
  //--------------------------------------------------------
  {
    path: '/',
    component: HomePage,
    name: 'Inicio',
    meta: createRouteMetaInfo({
      title: 'sele.ai - Tu Tutor de IA para Estudios',
      description: 'Transforma tus apuntes en un tutor de IA interactivo. Crea cuestionarios, resúmenes y flashcards de forma inteligente.',
      keywords: 'tutor ia, estudio inteligente, cuestionarios ia, resúmenes ia, flashcards ia'
    })
  },
  // {
  //   path: '/selectivitat',
  //   component: HomePageSele,
  //   name: 'Inicio',
  //   meta: createRouteMetaInfo({
  //     title: 'sele.ai - Tu Tutor de IA para Estudios',
  //     description: 'Transforma tus apuntes en un tutor de IA interactivo. Crea cuestionarios, resúmenes y flashcards de forma inteligente.',
  //     keywords: 'tutor ia, estudio inteligente, cuestionarios ia, resúmenes ia, flashcards ia'
  //   })
  // },

  //--------------------------------------------------------
  // 404
  //--------------------------------------------------------
  {
    path: '/404',
    component: () => import('./views/politiques/NotFoundComponent.vue'),
    meta: createRouteMetaInfo({
      title: 'Página no encontrada - SeleAI',
      description: 'La página que buscas no existe en sele.ai.',
      keywords: '404, página no encontrada, error, sele.ai'
    })
  },
  {
    path: '*',
    redirect: '/404'
  },
  
  // ---------------------------------
  // STUDY CONTENT
  // ---------------------------------
  {
    path: '/app/document/:documentId',
    component: () => import('./views/app/document/DocumentView.vue'),
    name: 'VistaDocumento',
    meta: createRouteMetaInfo({
      title: 'Documento - SeleAI',
      description: 'Visualiza tu documento y accede a los materiales de estudio generados.',
      keywords: 'documento, visualizar, estudio, sele.ai'
    })
  },
  {
    path: '/app/quiz/:documentId',
    component: () => import('./views/app/study/QuizView.vue'),
    name: 'CuestionarioEstudio',
    meta: createRouteMetaInfo({
      title: 'Cuestionario - SeleAI',
      description: 'Practica con cuestionarios generados por IA a partir de tus documentos.',
      keywords: 'cuestionario, preguntas, estudio, sele.ai'
    })
  },

  {
    path: '/study/:documentId',
    component: () => import('./views/app/study/StudyContentView.vue'),
    name: 'EstudioContenido',
    meta: createRouteMetaInfo({
      title: 'Contenido de Estudio - SeleAI',
      description: 'Visualiza y estudia el contenido generado para tus documentos: resúmenes, flashcards y cuestionarios.',
      keywords: 'estudio contenido, resumen, flashcards, cuestionario, sele.ai'
    })
  },
  {
    path: '/flashcards/:documentId',
    component: () => import('./views/app/study/FlashcardsView.vue'),
    name: 'FlashcardsEstudio',
    meta: createRouteMetaInfo({
      title: 'Flashcards - SeleAI',
      description: 'Estudia con tarjetas de memoria generadas por IA a partir de tus documentos.',
      keywords: 'flashcards, tarjetas memoria, estudio, sele.ai'
    })
  },
  {
    path: '/summary/:documentId',
    component: () => import('./views/app/study/SummaryView.vue'),
    name: 'ResumenEstudio',
    meta: createRouteMetaInfo({
      title: 'Resumen - SeleAI',
      description: 'Consulta resúmenes generados por IA a partir de tus documentos.',
      keywords: 'resumen, síntesis, estudio, sele.ai'
    })
  },
]

export default routes
